/**
 * Release 27 removed photo reading ("Dokumen jadi teks", owner 2026-10-31: every field is typed).
 * A device updated from an older release may still hold what it left, and photos are personal
 * data (a reading may show a NIK): the queue's photos and readings in OPFS `bacaan/`, the retired
 * document store's pages in OPFS `dokumen/` with their bookkeeping rows (`dokumen_lokal`, kept as
 * a table, emptied), and the queue's hold, consent and count in `sync_state`. On the first start
 * of this version over the real database, all of it goes, once, and `KUNCI_SISA_BACA` records
 * when. A reading never confirmed was never saved to a record, so nothing is kept; a confirmed one
 * already lives in its record. OPFS refusing records nothing: the next start tries again.
 * Platform-neutral: the worker passes its database and the OPFS folder removal.
 */
import type { DeviceDb } from './engine'

/** `sync_state`: when the old reading's leftovers were removed from this device. */
export const KUNCI_SISA_BACA = 'baca:sisa_dihapus'
/** The two top-level OPFS folders the old reading wrote. */
export const DIREKTORI_SISA_BACA = ['bacaan', 'dokumen'] as const
/** The `sync_state` keys the old reading kept: its hold, its cause, the consent, the count. */
export const KUNCI_STATE_BACA = [
  'baca:tahan_sampai',
  'baca:tahan_sebab',
  'baca:setuju_foto',
  'dokumen_lama:dihapus',
] as const

export interface SisaBacaDeps {
  /** Database work under the worker's mutex. */
  withDb<T>(fn: (db: DeviceDb) => T): Promise<T>
  /** Removes one top-level OPFS folder; absent is fine. */
  hapusDirektori(nama: string): Promise<void>
  now(): number
}

/** 'sudah': done at an earlier start, nothing touched; 'dihapus': removed now. */
export async function hapusSisaBaca(deps: SisaBacaDeps): Promise<'sudah' | 'dihapus'> {
  if ((await deps.withDb((db) => db.getState<string>(KUNCI_SISA_BACA))) !== undefined) {
    return 'sudah'
  }
  for (const nama of DIREKTORI_SISA_BACA) await deps.hapusDirektori(nama)
  await deps.withDb((db) => {
    db.exec('DELETE FROM dokumen_lokal')
    db.exec(
      `DELETE FROM sync_state WHERE kunci IN (${KUNCI_STATE_BACA.map(() => '?').join(', ')})`,
      [...KUNCI_STATE_BACA],
    )
    db.setState(KUNCI_SISA_BACA, new Date(deps.now()).toISOString())
  })
  return 'dihapus'
}
